
import Layout from '../../../components/Layout/MembersPortalLayout/MembersPortalLayout';
import React, { useRef, useEffect, useState, ChangeEvent } from 'react';
import { useNavigate, useParams } from 'react-router-dom';


import { ApiResponse } from '../../../interface/IResponse';
import { BorrowerLoan, BorrowerLoanDetails } from '../../../interface/MembersPortal/ILoan';
import BorrowerLoanTable from '../../../components/Table/LoanManagement/BorrowerLoanTable';
import loanService from './loanService';


function BorrowerLoanDetailsPage() {

    var navigate = useNavigate();

    var [borrowerLoanDetails, setBorrowerLoanDetails] = useState<BorrowerLoanDetails>({});

    async function loadBorrowerLoanDetails() {

        try {

            var axiosResponse = await loanService.getBorrowerLoanDetails();

            var response: ApiResponse<BorrowerLoanDetails> = axiosResponse.data;

            setBorrowerLoanDetails(response.result);

        }
        catch (err) {
            console.log('loadBorrowerLoanDetails err:: ', err);

        }
    }


    useEffect(function () {
        (async () => {
            document.querySelector('.loader-container')?.classList.add('loader');

            await loadBorrowerLoanDetails();

            document.querySelector('.loader-container')?.classList.remove('loader');
        })();
    }, []);

    return (
        <Layout>
            <div className="title-container">
                <div className="dv-title">
                    <h1>Borrower Details</h1>
                </div>
                <div className="title-btn-container vertical-flex-bottom">
                    <button
                        type="button"
                        id="btnBack"
                        onClick={() => {
                            navigate("/Admin/LoanManagement");
                        }}
                        className="btn-white-green-2 center-middle"
                    >
                        Back
                    </button>
                </div>
            </div>
            <br />
            <div className='content-container'>
                <div className='padding-container'>

                    <div>
                        <div className='label-2'>Member Name:</div>
                        <div className='label-2 font-bold' id='lblMemberName'>
                            {borrowerLoanDetails?.firstname} {borrowerLoanDetails?.lastname}
                        </div>
                    </div>
                    <div>
                        <div className='label-2'>ID:</div>
                        <div className='label-2 font-bold' id='lblId'>
                            {borrowerLoanDetails?.membershipId}
                        </div>
                    </div>
                    <div>
                        <div className='label-2'>Email:</div>
                        <div className='label-2 font-bold' id='lblEmail'>
                            {borrowerLoanDetails?.email}
                        </div>
                    </div>
                    <div>
                        <div className='label-2'>Amount Subscribed:</div>
                        <div className='label-2 font-bold' id='lblAmountSubscribed'>
                            {borrowerLoanDetails?.amountSubscribe}
                        </div>
                    </div>

                </div>
            </div>
            <br />
            <div className='content-container'>
                <div className='padding-container'>

                    <BorrowerLoanTable data={borrowerLoanDetails?.borrowerLoans ?? []} redirectUrlView='/Members/LoanStatusDetails/'></BorrowerLoanTable>

                </div>
            </div>
        </Layout>
    );


}

export default BorrowerLoanDetailsPage;